<template>
  <vue-page-wrapper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="Industry Report"
        subtitle="Here you can compare report of different types of industries"
        :icon="$getIcon('mdiDomain')"
      >
      </vue-card-title>
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col cols="4">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Industry Name
                  </th>
                  <th class="text-left">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody class="grey lighten-4">
                <tr v-for="(item, index) in industryReport" :key="index">
                  <td>
                    {{ item.industry_name || "-" }}
                  </td>
                  <td class="body-2 font-weight-bold">
                    {{ item.total || "-" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="8">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(user, indexx) of industryReport.length &&
                      industryReport[0].users"
                    :key="indexx"
                    class="text-center"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <a>
                          <v-avatar :size="35" v-on="on">
                            <v-img
                              :src="
                                user.picture ||
                                  require(`@/static/images/info/user-default.png`)
                              "
                              alt="CRE avatar"
                            ></v-img>
                          </v-avatar>
                        </a>
                      </template>
                      <span v-text="user.full_name || ''"></span>
                    </v-tooltip>
                  </th>
                </tr>
              </thead>
              <tbody v-if="industryReport.length">
                <tr v-for="(item, indexxxx) in industryReport" :key="indexxxx">
                  <td
                    class="text-center"
                    v-for="(userItem, indexxxx) in item.users"
                    :key="indexxxx"
                  >
                    {{ userItem.count || "-" }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <vue-data-table-no-data
                  :loading="loading"
                ></vue-data-table-no-data>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card>
  </vue-page-wrapper>
</template>

<script>
export default {
  data() {
    return {
      htmlTitle: "Industry",
      breadCrumbs: [
        { text: "Report", disabled: true },
        {
          text: `Industry`,
          disabled: true
        }
      ],
      industryReport: [],
      loading: false
    };
  },
  created() {
    this.getIndustryReport();
  },
  methods: {
    getIndustryReport() {
      this.loading = true;
      this.$axios.$get("/api/v1/crm/report/industry").then(response => {
        this.industryReport = response;
        this.loading = false;
      });
    }
  }
};
</script>
